import GuidedCaptureOption from 'owa-guided-capture-option/lib/GuidedCaptureOption';
import { OptionSubCategory } from 'owa-options-core';

const intelligenceSubCategory: OptionSubCategory = {
    key: 'intelligence',
    titleStringKey: 'optionSubcategory_intelligence',
    options: [GuidedCaptureOption],
};

export default intelligenceSubCategory;
